import { Pipe } from '@angular/core';

@Pipe({
  name: 'formErrorMessage',
  standalone: true,
})
export class FormErrorMessagePipe {
  transform(error: any): string {
    if (!error) return '';

    // Si el error es un array (Angular 17+ with ValidationErrors)
    const firstError = Array.isArray(error) ? error[0] : error;

    // Mensaje personalizado
    if (firstError.message) return firstError.message;

    // Compatibilidad: algunos usan "kind" en vez de "type"
    const type = firstError.kind || firstError.type;

    switch (type) {
      case 'required':
        return 'Este campo es requerido';
      case 'min':
        return 'El valor es demasiado bajo';
      case 'max':
        return 'El valor es demasiado alto';
      default:
        return 'Campo inválido';
    }
  }
}
